module.exports = __webpack_public_path__ + "img/1697164584703-WhatsApp Image 2023-10-13 at 10.29.40 1.jpeg.2ecdc96e.webp";